/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEligibilityStatus } from '../models/db_DropdownEligibilityStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EligibilityStatuses {
    /**
     * Get a list of eligibility statuses
     * @returns db_DropdownEligibilityStatus OK
     * @throws ApiError
     */
    public static listEligibilityStatuses(): CancelablePromise<Array<db_DropdownEligibilityStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/eligibility-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
